import _ from 'lodash';
import { LAYOUT_TYPE_PATH, CARD_SIZE_PATH } from '../constants/wix-params';
import { UPDATE_APP_SETTINGS_REQUEST } from '../actions/update-app-settings';
import getLayoutName from '../services/get-layout-name';

export const eventMap = {
  [UPDATE_APP_SETTINGS_REQUEST]: action => {
    if (action.meta && action.meta.bi && action.meta.bi.externalId !== 'draft') {
      return {
        evid: 12,
        setting_input_json: JSON.stringify({
          layoutName: getLayoutName(_.get(action.payload, LAYOUT_TYPE_PATH), _.get(action.payload, CARD_SIZE_PATH)),
        }),
      };
    }
  },
};

export const endpoint = 'forums-users';
export const src = 69;



// WEBPACK FOOTER //
// ./app/bi-events/forums-users-events.js